module.exports = __webpack_public_path__ + "img/settings.2f6a6999.svg";